import { render, staticRenderFns } from "./infoModal.vue?vue&type=template&id=37f6b13d&scoped=true&"
import script from "./infoModal.vue?vue&type=script&lang=js&"
export * from "./infoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f6b13d",
  null
  
)

export default component.exports